export enum OrderDistributionStatus {
  NOT_STARTED = 'notStarted',
  FINISHED = 'finished',
  UNAVAILABLE = 'unavailable',
  SILO_CHANGED = 'siloConfigChanged',
}
